(function () {
	'use strict';
	angular.module('app.setup')
		.controller('emailReport', emailReport);
    
	function emailReport($rootScope, $scope, leanFilterService, tableRenderService, $timeout,
			tableService, pageTimingService) {
        
		var vm = this;
		var timingCalled = false;
		var getDataCalled = false;
		var showRowsCalled = false;
		var extraParams = [{
			showExcel: true,
			excelReportName: 'EmailMessageReport'
		}];

		vm.getData = getData;
		vm.getMeta = getMeta;
		vm.broadcastExcel = broadcastExcel;

		var columnList = columns();
		var pinnedColumnList = [];

		vm.reportName = 'Email Report';

		var userTimingListener = $scope.$on('showRowsCalled', function () {
			showRowsCalled = true;
			submitUserTiming();
		});
		$scope.$on('$destroy', function () {
			userTimingListener();
		});

		function submitUserTiming() {
			if (getDataCalled && showRowsCalled && !timingCalled) {
				pageTimingService.submitUserTiming('Email Report');
				timingCalled = true;
			}
		}

		var reportSettingsName = 'emailReport';
		var rendererParams = {};
		var defaultFilters = [];

		vm.extraFilters = [];
		vm.showExcel = true;
		leanFilterService.clearFilters();
		leanFilterService.useFactoryFilter = false;
		var filters = [
			leanFilterService.filterDefinitions['CustomersForUser'],
			leanFilterService.filterDefinitions['EmailTags'],
			leanFilterService.filterDefinitions['EmailDelivered'],
			leanFilterService.filterDefinitions['EmailBounced'],
			leanFilterService.filterDefinitions['EmailRejected'],
			leanFilterService.filterDefinitions['EmailComplained']
		];
		leanFilterService.setMasterFilterList(filters);
		leanFilterService.setMasterRangeFilterList([leanFilterService.filterDefinitions['TimeSent']]);
		leanFilterService.searchType = 'email';

		function getMeta() {
			return {
				reportSettingsName: reportSettingsName,
				noPaging: false,
				pageSize: 50,
				defaultFilters: defaultFilters,
				defaultSort: 'timeSent',
				defaultSortDirection: 'desc',
				rendererParams: rendererParams,
				extraParams: extraParams,
				columns: columnList,
				reportUrl: 'EmailMessageReport' ,
				pinnedColumns: pinnedColumnList,
				hideSearch: false,
				footer: false,
				setColumnDefaults: true,
				noFactory: true,
				searchType: 'email',
				specialPlaceholderText: 'Search to or subject',
				isGlobalReportSetting: true,
				excelRequest: true,
				useReportBuilderForExcel: true,
				excelReportName: 'EmailMessageReport',
				includeAllColumnsForExcel: true
			};
		}

		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', { columns: columnList, doChooseColumns: true });
		}

		function getData(params, extraParams) {
			return tableService.postData(params, extraParams, getReportColumns()).then(function (response) {
				getDataCalled = true;
				return response;
			});
		}

		function getReportColumns() {
			var newColumns = [
				'customerNdx', 'message'
			];
			newColumns = _.map(newColumns, function(val) {
				return {id: val};
			});
			return columns().concat(newColumns);
		}

		function columns() {
			return [
				{
					id: 'customerName',
					display: 'Customer',
					sort: false
				},
				{
					id: 'timeSent',
					display: 'Time Sent',
					renderer: tableRenderService.dateTime,
					width: 150,
					sortDefaultReverse: true
				},
				{
					id: 'to',
					display: 'To Address',
					width: 170,
					renderer: tableRenderService.emailAddressToUserPage
				},
				{
					id: 'from',
					display: 'From Address',
					show: false,
					width: 150
				},
				{
					id: 'cc',
					display: 'CC Address',
					show: false,
					width: 150
				},{
					id: 'subject',
					display: 'Subject',
					width: 250,
					renderer: tableRenderService.emailContent
				},
				{
					id: 'wasDelivered',
					display: 'Delivered',
					renderer: tableRenderService.yesNo
				},
				{
					id: 'wasBounced',
					display: 'Bounced',
					renderer: tableRenderService.yesNo,
					sortDefaultReverse: true
				},
				{
					id: 'wasRejected',
					display: 'Rejected',
					renderer: tableRenderService.yesNo,
					sortDefaultReverse: true
				},
				{
					id: 'wasOpened',
					display: 'Opened',
					renderer: tableRenderService.yesNo,
					sortDefaultReverse: true
				},
				{
					id: 'wasClicked',
					display: 'Clicked',
					renderer: tableRenderService.yesNo,
					sortDefaultReverse: true
				},
				{
					id: 'wasComplained',
					display: 'Marked spam',
					renderer: tableRenderService.yesNo,
					sortDefaultReverse: true
				},
				{
					id: 'tag',
					display: 'Tag',
					width: 150
				}
			];
		}
	
	}
})();
